import * as types from '../actions/types';

const initState = {
    list: null,
    loading: false,
    loadingError: null,

    progress: 0
};

export default function ImportantDocumentsReducer (state = initState, action) {
    switch (action.type) {

        case types.IMPORTANT_DOCUMENTS_LOAD:
            return {...state, loading: true, loadingError: null, list: null };

        case types.IMPORTANT_DOCUMENTS_LOAD_SUCCESS:
            return {...state, loading: false, loadingError: null, list: action.payload.list, progress: action.payload.progress };

        case types.IMPORTANT_DOCUMENTS_LOAD_ERROR:
            return {...state, loading: false, loadingError: action.payload, list: null };

        default:
            return state;
    }
}
